module.exports = "/_next/static/images/f8caafbdc2d506b985943de96f2f2390-rewards-app-md@2x.png.webp";